import { observable, action } from 'mobx'

class StockSearchModel {
    @observable
    public keyWord: string = ''

    @action
    public setKeyWord(word: string) {
        this.keyWord = word
    }
}

export const stockSearchModel = new StockSearchModel()
